<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <div class="row">
        <h4>Fotos carrocería Motos</h4>
        <!-- FOTO DEL TABLERO KM-->
        <div v-if="isFieldVisible('motorcycle_photo_km_dashboard')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="motorcycle_photo_km_dashboard" class="form-label text-left">{{ getFieldDescription('motorcycle_photo_km_dashboard') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('motorcycle_photo_km_dashboard')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'motorcycle_photo_km_dashboard'"
                  :id="'motorcycle_photo_km_dashboard'"
                  style="display: none;"
                  @change="onFileChange('motorcycle_photo_km_dashboard')"
                />
              </div>
            </div>
            <div class="btn tbn-block btn-custom mt-3" v-if="motorcycle_photo_km_dashboard" @click="openImageModal(motorcycle_photo_km_dashboard)">Ver Imagen</div>
          </div>
        </div>
        <!-- FOTO FRENTE -->
        <div v-if="isFieldVisible('motorcycle_photo_front')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="motorcycle_photo_front" class="form-label text-left">{{ getFieldDescription('motorcycle_photo_front') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('motorcycle_photo_front')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'motorcycle_photo_front'"
                  :id="'motorcycle_photo_front'"
                  style="display: none;"
                  @change="onFileChange('motorcycle_photo_front')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="motorcycle_photo_front" @click="openImageModal(motorcycle_photo_front)">Ver Imagen</div>
          </div>
        </div>
        <!-- FOTO LATERAL IZQUIERDO -->
        <div v-if="isFieldVisible('motorcycle_photo_left_side')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="motorcycle_photo_left_side" class="form-label text-left">{{ getFieldDescription('motorcycle_photo_left_side') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('motorcycle_photo_left_side')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'motorcycle_photo_left_side'"
                  :id="'motorcycle_photo_left_side'"
                  style="display: none;"
                  @change="onFileChange('motorcycle_photo_left_side')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="motorcycle_photo_left_side" @click="openImageModal(motorcycle_photo_left_side)">Ver Imagen</div>
          </div>
        </div>
        <!-- FOTO LATERAL DERECHO -->
        <div v-if="isFieldVisible('motorcycle_photo_right_side')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="motorcycle_photo_right_side" class="form-label text-left">{{ getFieldDescription('motorcycle_photo_right_side') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('motorcycle_photo_right_side')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'motorcycle_photo_right_side'"
                  :id="'motorcycle_photo_right_side'"
                  style="display: none;"
                  @change="onFileChange('motorcycle_photo_right_side')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="motorcycle_photo_right_side" @click="openImageModal(motorcycle_photo_right_side)">Ver Imagen</div>
          </div>
        </div>
        <!-- FOTO ATRAS -->
        <div v-if="isFieldVisible('motorcycle_photo_back')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="motorcycle_photo_back" class="form-label text-left">{{ getFieldDescription('motorcycle_photo_back') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('motorcycle_photo_back')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'motorcycle_photo_back'"
                  :id="'motorcycle_photo_back'"
                  style="display: none;"
                  @change="onFileChange('motorcycle_photo_back')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="motorcycle_photo_back" @click="openImageModal(motorcycle_photo_back)">Ver Imagen</div>
          </div>
        </div>
        <!-- FOTO MOTOR -->
        <div v-if="isFieldVisible('motorcycle_photo_engine')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
            <label for="motorcycle_photo_engine" class="form-label text-left">{{ getFieldDescription('motorcycle_photo_engine') }}</label>
          </div>
            <div>
            <div>
                <div @click="openCamera('motorcycle_photo_engine')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'motorcycle_photo_engine'"
                  :id="'motorcycle_photo_engine'"
                  style="display: none;"
                  @change="onFileChange('motorcycle_photo_engine')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="motorcycle_photo_engine" @click="openImageModal(motorcycle_photo_engine)">Ver Imagen</div>
          </div>
        </div>
        <!-- FOTO VIN CHASIS -->
        <div v-if="isFieldVisible('motorcycle_photo_vin_chasis')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="motorcycle_photo_vin_chasis" class="form-label text-left">{{ getFieldDescription('motorcycle_photo_vin_chasis') }}</label>
            </div>
            <div>
              <div>
                <div @click="openCamera('motorcycle_photo_vin_chasis')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'motorcycle_photo_vin_chasis'"
                  :id="'motorcycle_photo_vin_chasis'"
                  style="display: none;"
                  @change="onFileChange('motorcycle_photo_vin_chasis')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="motorcycle_photo_vin_chasis" @click="openImageModal(motorcycle_photo_vin_chasis)">Ver Imagen</div>
          </div>
        </div>
      </div>
      <hr class="custom-hr mt-4" />
    </div>
  </div>
    
  <!-- MODAL -->
  <ShowImagesModal
  :modalId="'imageModalPhotoMotorcycle'"
  :currentImage="currentImage"
  :currentImageName="currentImageName"
  />
</template>

<script>
import { ref, onMounted } from 'vue';
import ShowImagesModal from '../../modals/ShowImages';
import ImageCompressor from 'image-compressor.js';
import { rotateImageIfNeeded } from '../../../Utils/imageUtils';  


export default {
  name: 'FormPhotoMotorcycle',
  props: {
    data: Object,
  },
  components: {
    ShowImagesModal,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);
    const currentImage = ref(null);
    const currentImageName = ref('');

    const motorcycle_photo_km_dashboard = ref(null);
    const motorcycle_photo_front = ref(null);
    const motorcycle_photo_left_side = ref(null);
    const motorcycle_photo_right_side = ref(null);
    const motorcycle_photo_back = ref(null);
    const motorcycle_photo_engine = ref(null);
    const motorcycle_photo_vin_chasis = ref(null);

    const formData = ref({
      motorcycle_photo_km_dashboard_id: null,
      motorcycle_photo_front_id: null,
      motorcycle_photo_left_side_id: null,
      motorcycle_photo_right_side_id: null,
      motorcycle_photo_back_id: null,
      motorcycle_photo_engine_id: null,
      motorcycle_photo_vin_chasis_id: null,
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (
          dataCompany.value &&
          (dataCompany.value.motorcycle_photo_km_dashboard ||
            dataCompany.value.motorcycle_photo_front ||
            dataCompany.value.motorcycle_photo_left_side ||
            dataCompany.value.motorcycle_photo_right_side ||
            dataCompany.value.motorcycle_photo_back ||
            dataCompany.value.motorcycle_photo_engine ||
            dataCompany.value.motorcycle_photo_vin_chasis)
        );
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const openImageModal = (imageFile) => {
      currentImage.value = URL.createObjectURL(imageFile);
      currentImageName.value = imageFile.name;
      $('#imageModalPhotoMotorcycle').modal('show');
    };

    const onFileChange = async (fieldName) => {
      const fileFields = {
        motorcycle_photo_km_dashboard: motorcycle_photo_km_dashboard,
        motorcycle_photo_front: motorcycle_photo_front,
        motorcycle_photo_left_side: motorcycle_photo_left_side,
        motorcycle_photo_right_side: motorcycle_photo_right_side,
        motorcycle_photo_back: motorcycle_photo_back,
        motorcycle_photo_engine: motorcycle_photo_engine,
        motorcycle_photo_vin_chasis: motorcycle_photo_vin_chasis,
      };

      const fileInput = document.getElementById(fieldName);

      try {
        const rotatedFile = await rotateImageIfNeeded(fileInput.files[0], 90);
        const compressedFile = await compressImage(rotatedFile);
        fileFields[fieldName].value = compressedFile;
        emitFieldChanged();
      } catch (error) {
        console.error('Error al comprimir la imagen:', error);
      }
    };

    const compressImage = (file) => {
      return new Promise((resolve, reject) => {
        const compressor = new ImageCompressor();
        compressor.compress(file, {
          maxWidth: 800,
          maxHeight: 600,
          quality: 1,
          mimeType: 'image/jpeg',
          success(result) {
            resolve(result);
          },
          error(error) {
            reject(error);
          },
        });
      });
    };


    const emitFieldChanged = () => {
      const formFields = {
        motorcycle_photo_km_dashboard_id: motorcycle_photo_km_dashboard.value,
        motorcycle_photo_front_id: motorcycle_photo_front.value,
        motorcycle_photo_left_side_id: motorcycle_photo_left_side.value,
        motorcycle_photo_right_side_id: motorcycle_photo_right_side.value,
        motorcycle_photo_back_id: motorcycle_photo_back.value,
        motorcycle_photo_engine_id: motorcycle_photo_engine.value,
        motorcycle_photo_vin_chasis_id: motorcycle_photo_vin_chasis.value,
      };

      const validFields = {};
      for (const [key, value] of Object.entries(formFields)) {
        if (dataCompany.value && dataCompany.value[key.replace('_id', '')]) {
          validFields[key] = value;
        }
      }

      formData.value = validFields;
      emit('formDataChanged', formData.value);
    };

    const openCamera = async (fieldName) => {
      try {
        const inputElement = document.getElementById(fieldName);
        inputElement.click();
      } catch (error) {
        console.error('Error al abrir la ventana de selección de archivo:', error);
      }
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      openImageModal,
      onFileChange,
      currentImage,
      currentImageName,
      emitFieldChanged,
      formData,
      motorcycle_photo_km_dashboard,
      motorcycle_photo_front,
      motorcycle_photo_left_side,
      motorcycle_photo_right_side,
      motorcycle_photo_back,
      motorcycle_photo_engine,
      motorcycle_photo_vin_chasis,
      openCamera,
    };
  },
};
</script>

